module.exports = __webpack_public_path__ + "img/20200507_134634.909ed16b.jpg";